{
  "bookingWidgetTabs": {
    "carTrawler": {
      "title": "Vuokraa auto ja kerää Avioksia",
      "poweredBy": "Powered by",
      "pickupLocation": "Noutopaikka",
      "pickupAndDropoff": "Nouto- ja palautuspaikka",
      "dropoffLocation": "Palautuspaikka",
      "locationPlaceholder": "Kaupunki tai lentoasema",
      "locationSearchPlaceholder": "Kirjoita ja valitse sijainti",
      "differentDropoff": "Palauta eri paikkaan",
      "pickupDate": "Noutopäivä",
      "dropoffDate": "Palautuspäivä",
      "time": "Aika",
      "selectTimePlaceholder": "Valitse aika",
      "pickupTime": "Noutoaika",
      "dropoffTime": "Palautusaika",
      "driverAge": "Kuljettajan ikä",
      "driverAgeSelection": {
        "label": "Kuljettajan ikä",
        "other": "Muu"
      },
      "ctaButton": "Hae autoja"
    },
    "hotels": {
      "title": "Varaa hotelli ja kerää Avioksia",
      "poweredBy": "Palveluntarjoaja",
      "destination": "Minne olet menossa?",
      "destinationPlaceholder": "Lisää kohde",
      "destinationSearchPlaceholder": "Kirjoita ja valitse kohde",
      "checkInDate": "Alkaa",
      "checkOutDate": "Päättyy",
      "guestsAndRooms": "Yöpyjät ja huoneet",
      "room": "Huone",
      "remove": "Poista",
      "addRoom": "Lisää huone",
      "ctaButton": "Hae hotelleja",
      "guests": {
        "adult": "Aikuinen",
        "child": "Lapsi 0 - 17",
        "totalRooms": {
          "singular": "{0} huone",
          "plural": "{0} huonetta"
        },
        "totalAdults": {
          "singular": "{0} aikuinen",
          "plural": "{0} aikuista"
        },
        "totalChildren": {
          "singular": "{0} lapsi",
          "plural": "{0} lasta"
        },
        "ageUponCheckIn": "Ikä saapumispäivänä",
        "ageOfChild": "Lapsen ikä",
        "ageSelect": "Valitse",
        "addAdult": "Lisää aikuinen",
        "removeAdult": "Poista aikuinen",
        "addChild": "Lisää lapsi",
        "removeChild": "Poista lapsi",
        "year": "vuosi",
        "years": "vuotta",
        "childAge": {
          "required": "Valitse lapsen ikä"
        }
      },
      "aviosNotification": "Lisäksi Finnair Plus -jäsenenä voit varata hotelleja jäsenhintaan."
    }
  }
}
